import {
  CheckCircleFilledSVG,
  MinusCircleFilledSVG,
  PlusCircleFilledSVG,
  SvgComponentType,
  QuestionFilledSVG,
} from "@newsela/angelou";

import DataInfoCard, { DataInfoCardVariant } from "@/components/DataInfoCard";
import { dataInfoCardCss } from "@/reports/teacher/common/OverviewDataResults/OverviewDataResults.style";

export enum ValidReadingLevelStatus {
  equal = "equal",
  below = "below",
  above = "above",
  noActivity = "noActivity",
}

interface CardValuesByReadingLevelStatus {
  statusText: string;
  textContent: string;
  iconSvgComponent: SvgComponentType;
}

interface StudentReadingGradeLevelProps {
  studentFirstName: string;
  studentReadingLevelStatus: ValidReadingLevelStatus;
  articlesViewedCount: number;
}

const StudentReadingGradeLevel = (props: StudentReadingGradeLevelProps) => {
  const { studentFirstName, articlesViewedCount, studentReadingLevelStatus } =
    props;
  const readingLevelStatus: Record<
    ValidReadingLevelStatus,
    CardValuesByReadingLevelStatus
  > = {
    [ValidReadingLevelStatus.equal]: {
      statusText: "On grade level",
      textContent: `Based on ${articlesViewedCount} texts, ${studentFirstName} usually views on-grade level texts`,
      iconSvgComponent: CheckCircleFilledSVG,
    },
    [ValidReadingLevelStatus.below]: {
      statusText: "Below grade level",
      textContent: `Based on ${articlesViewedCount} texts, ${studentFirstName} usually views texts below grade level`,
      iconSvgComponent: MinusCircleFilledSVG,
    },
    [ValidReadingLevelStatus.above]: {
      statusText: "Above grade level",
      textContent: `Based on ${articlesViewedCount} texts, ${studentFirstName} usually views texts above grade level`,
      iconSvgComponent: PlusCircleFilledSVG,
    },
    [ValidReadingLevelStatus.noActivity]: {
      statusText: "Reading level",
      textContent:
        "This widget shows if a student is reading Newsela texts at their grade level",
      iconSvgComponent: QuestionFilledSVG,
    },
  };
  return (
    <DataInfoCard
      variant={DataInfoCardVariant.icon}
      iconSvgComponent={
        readingLevelStatus[
          articlesViewedCount === 0
            ? ValidReadingLevelStatus.noActivity
            : studentReadingLevelStatus
        ]?.iconSvgComponent
      }
      statusText={
        readingLevelStatus[
          articlesViewedCount === 0
            ? ValidReadingLevelStatus.noActivity
            : studentReadingLevelStatus
        ]?.statusText
      }
      textContent={
        readingLevelStatus[
          articlesViewedCount === 0
            ? ValidReadingLevelStatus.noActivity
            : studentReadingLevelStatus
        ]?.textContent
      }
      additionalStyles={{ containerCss: dataInfoCardCss(false) }}
    />
  );
};

export default StudentReadingGradeLevel;
